/**
 * Single-patient eligibility details view: 3/4 details column and 1/4 patient
 * notes, with the actions and history rail available but hidden.
 */
import ChatPanel from "./ChatPanel";
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";

/**
 * Whether the Actions / Status / Runs rail renders between details and chat.
 *
 * The rail is complete and covered by tests; it is hidden because the detail
 * payload's actions, overrides, and history are not wanted in the layout yet.
 * Flip to `true` to bring the column back.
 */
/** When false, the details column uses the full width (notes / rail hidden). */
const SHOW_ACTIONS_RAIL = false;

/** Patient notes column beside eligibility details. */
const SHOW_CHAT_PANEL = true;

/**
 * Layout shell for the single-patient eligibility details screen.
 *
 * @returns The eligibility details screen
 */
const SinglePatientEligibilityDetailsView = () => {
  return (
    <div className="single-patient-eligibility-details__container flex h-full min-h-0 w-full overflow-hidden">
      <LeftPanel />
      {SHOW_ACTIONS_RAIL && <RightPanel />}
      {SHOW_CHAT_PANEL && <ChatPanel />}
    </div>
  );
};

export default SinglePatientEligibilityDetailsView;
